import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FuseLoadingService } from "@fuse/services/loading";
import { finalize, Observable } from "rxjs";

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    constructor(private readonly loaderService: FuseLoadingService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.context.get(SKIP_GLOBAL_LOADER) || this.filterUrl(request.url)) return next.handle(request);
        this.loaderService.show();
        return next.handle(request).pipe(
            finalize(() => this.loaderService.hide()),
        );
    }
    private filterUrl(url: string): boolean {
        if (url.includes("select-options") || url.includes("get-address-from-zip-code") || url.includes("RouteEntries")) return true;
        return false;
    }
}
